import React from 'react'
import PropTypes from 'prop-types'
import {Typography} from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'
import {MAX_SELECTION_LIMIT, warningColors} from './constants'

const SelectionStatus = ({selectedOptionsLength, isAtLimit, isNearLimit}) => {
  if (isAtLimit) {
    return (
      <Typography
        style={{
          fontSize: '12px',
          color: warningColors.atLimit,
          marginTop: '8px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <WarningIcon style={{fontSize: '16px', marginRight: '4px', color: warningColors.atLimit}} />
        Maximum of {MAX_SELECTION_LIMIT} selections reached. Too many selections may cause API
        errors.
      </Typography>
    )
  }

  if (isNearLimit) {
    return (
      <Typography
        style={{
          fontSize: '12px',
          color: warningColors.nearLimit,
          marginTop: '8px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <WarningIcon
          style={{fontSize: '16px', marginRight: '4px', color: warningColors.nearLimit}}
        />
        {selectedOptionsLength}/{MAX_SELECTION_LIMIT} selections. Consider limiting selections to
        avoid API errors.
      </Typography>
    )
  }

  return null
}

SelectionStatus.propTypes = {
  selectedOptionsLength: PropTypes.number.isRequired,
  isAtLimit: PropTypes.bool.isRequired,
  isNearLimit: PropTypes.bool.isRequired,
}

export default SelectionStatus
